import { MasterDetailModule } from 'ag-grid-enterprise';
import { ISearchResponse, tradesBlotterApiConnector } from 'apiConnector/blotters';
import { useServerSideConnect } from 'components/Blotters/Trades/Grid/connect/useServerSideConnect';
import { DlpProductTradeGrid } from 'components/Blotters/Trades/Grid/dlp-product-trade-grid';
import { useDlpTradesBlottersProps } from 'components/Blotters/Trades/Grid/hooks/useDlpTradeBlottersProps';
import { ServerSideBlotterGrid } from 'components/shared/Blotter/Grid/blotter-serverside';
import { useDefaultSortTranslator } from 'components/shared/Blotter/Grid/Hooks/useDefaultTranslators';
import { useGridAutoRefresh } from 'components/shared/Blotter/Grid/Hooks/useGridAutoRefresh';
import { useServerSideBlotterDataSource } from 'components/shared/Blotter/Grid/Hooks/useServerSideDatasource';
import { BlotterRequestByBlotterType, DlpBlotterTopRequest } from 'epic/blotters/tradesBlotter/tradesBlottersEpic';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Observable } from 'rxjs';
import { tradesBlottersItemsPerPageChanged } from 'state/blotters/trades/tradesBlotters.actions';
import { DlpProductBlotterItem } from 'state/blotters/trades/types/blotterItem';
import { httpClient } from 'utils/http/httpClient';

type DlpRequest = BlotterRequestByBlotterType<'dlpProducts'>;

function searchItems(request: DlpRequest): Observable<ISearchResponse<DlpProductBlotterItem>> {
  const api = tradesBlotterApiConnector(httpClient);
  return api.search<'dlpProducts'>(request, 'dlpProducts');
}
const canSetActive = () => true;
const modules = [MasterDetailModule];

export function DlpProductsGrid() {
  const { columnTypes, defaultColumnDef, getContextMenuItems, gridReady, gridApi } = useDlpTradesBlottersProps();

  const { blotterRequest, onItemsReceived, onRequestFailed, onItemsRequested, ...connectedProps } =
    useServerSideConnect({
      blotter: 'dlpProducts',
      idKey: 'isin',
    });

  const translateSort = useDefaultSortTranslator();

  const serverSideDatasource = useServerSideBlotterDataSource<DlpRequest, DlpBlotterTopRequest, DlpProductBlotterItem>({
    blotterRequest,
    translateRequest: (gridRequest, topRequest) => {
      const sort = translateSort(gridRequest);
      return { ...topRequest, sort };
    },
    searchItems,
    onItemsReceived,
    onItemsRequested,
    onRequestFailed,
    isNativePaginationEnabled: true,
  });
  const dispatch = useDispatch();
  const onPageSizeChanged = useCallback(
    (pageSize: number) => {
      dispatch(tradesBlottersItemsPerPageChanged('dlpProducts', pageSize));
    },
    [dispatch],
  );
  useGridAutoRefresh(gridApi);

  return (
    <>
      <ServerSideBlotterGrid<DlpRequest, DlpProductBlotterItem>
        {...connectedProps}
        serverSideDatasource={serverSideDatasource}
        e2e="dlp-product-blotter"
        name="dlpProducts"
        logAnalyticName="Blotter My flow products"
        columnTypes={columnTypes}
        canSetActive={canSetActive}
        defaultColDef={defaultColumnDef}
        onGridReady={gridReady}
        masterDetail
        modules={modules}
        isRowMaster={data => data.hasTrades === true}
        detailCellRenderer={DlpProductTradeGrid}
        detailRowAutoHeight
        getContextMenuItems={getContextMenuItems}
        useNativePagination
        onPageSizeChanged={onPageSizeChanged}
      />
    </>
  );
}
